import React from 'react'
import Page404 from "../../assets/styles/images/page-404.gif"

function error404() {
  return (
    <div className="text-center three-login-bg login_center min-vh-100" >
    <img src={Page404} alt="page Not Found"/>
    </div>
  )
}

export default error404